import { getData } from '../../axiosServices'

const getAttendanceApiPrefix = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user')) || {};
        const role = String(user?.role || '').toLowerCase().trim();
        if (role === 'coe_report_viewer' || role.includes('report_viewer') || role.includes('reportviewer')) {
            return 'reportViewer';
        }
        if (typeof window !== 'undefined' && (
            window.location?.pathname?.includes('/learner-attendance') ||
            window.location?.pathname?.includes('report-viewer') ||
            window.location?.pathname?.includes('reportViewer')
        )) {
            return 'reportViewer';
        }
    } catch {
        // fallback
    }
    return 'reports';
};

export const getTimeSlotsByLabType = (coeId, labType, attendanceName) => {
    const url = `labDailyAttendance/timeSlotsForAdminReport?coe_id=${coeId}&lab_type=${labType}&attendanceName=${attendanceName}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

export const getReportForReportViewer = (coeId, semester = '', labType = '', timeSlot = '', fromDate = '', toDate = '', attendanceName = '', enrollmentYear = 2025, passoutYear = 2029) => {
    const queryParts = [];
    if (coeId) queryParts.push(`coeID=${encodeURIComponent(coeId)}`);
    if (enrollmentYear) queryParts.push(`enrollment_year=${encodeURIComponent(enrollmentYear)}`);
    if (passoutYear) queryParts.push(`passout_year=${encodeURIComponent(passoutYear)}`);
    if (semester) queryParts.push(`semester=${encodeURIComponent(semester)}`);
    if (labType) queryParts.push(`lab_type=${encodeURIComponent(labType)}`);
    if (timeSlot) queryParts.push(`timeSlot=${encodeURIComponent(timeSlot)}`);
    if (attendanceName) queryParts.push(`attendance_name=${encodeURIComponent(attendanceName)}`);
    if (fromDate) queryParts.push(`fromDate=${encodeURIComponent(fromDate)}`);
    if (toDate) queryParts.push(`toDate=${encodeURIComponent(toDate)}`);

    const url = `reportViewer/attendance_report_admin?${queryParts.join('&')}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

export const getReportForAdmin = (coeId, labType = '', timeSlot = '', fromDate = '', toDate = '', attendanceName = '', semester = '', isViewerParam = null) => {
    let isReportViewer = isViewerParam;
    if (isReportViewer === null) {
        isReportViewer = getAttendanceApiPrefix() === 'reportViewer';
    }

    if (isReportViewer) {
        return getReportForReportViewer(coeId, semester, labType, timeSlot, fromDate, toDate, attendanceName);
    }

    const queryParts = [];
    if (coeId) {
        queryParts.push(`coeID=${encodeURIComponent(coeId)}`);
        queryParts.push(`coe_id=${encodeURIComponent(coeId)}`);
    }
    if (labType) queryParts.push(`lab_type=${encodeURIComponent(labType)}`);
    if (timeSlot) queryParts.push(`timeSlot=${encodeURIComponent(timeSlot)}`);
    if (attendanceName) queryParts.push(`attendance_name=${encodeURIComponent(attendanceName)}`);
    if (fromDate) queryParts.push(`fromDate=${encodeURIComponent(fromDate)}`);
    if (toDate) queryParts.push(`toDate=${encodeURIComponent(toDate)}`);
    if (semester) queryParts.push(`semester=${encodeURIComponent(semester)}`);

    const url = `reports/attendance_report_admin?${queryParts.join('&')}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

export const getPresentAbsent = (coeId, labID, date, dailyAttendanceId) => {
    const prefix = getAttendanceApiPrefix();
    const url = `${prefix}/attendance-status?coe_id=${coeId}&dailyAttendanceId=${dailyAttendanceId}&lab_id=${labID}&attendanceDate=${date}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

export const refreshAttendanceReport = async (labID, coeId, date) => {
    const prefix = getAttendanceApiPrefix();
    const url = `${prefix}/attendance_report?attendanceDate=${date}&coe_id=${coeId}&lab_id=${labID}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
};

export const getAttendanceByCoe = (coeId, labType) => {
    const url = `labDailyAttendance/attendanceNameOfCoe/?coe_id=${coeId}&lab_type=${labType}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

export const getReportForAdminByStrength = (coeId, labType, timeSlot, attendanceName, forDate, labId, isViewerParam = null) => {
    let prefix = getAttendanceApiPrefix();
    if (isViewerParam === true) prefix = 'reportViewer';
    if (isViewerParam === false) prefix = 'reports';

    const queryParts = [];
    if (labType) queryParts.push(`lab_type=${encodeURIComponent(labType)}`);
    if (coeId) queryParts.push(`coeID=${encodeURIComponent(coeId)}`);
    if (timeSlot) queryParts.push(`timeSlot=${encodeURIComponent(timeSlot)}`);
    if (attendanceName) queryParts.push(`attendance_name=${encodeURIComponent(attendanceName)}`);
    if (forDate) queryParts.push(`forDate=${encodeURIComponent(forDate)}`);
    if (labId) queryParts.push(`labId=${encodeURIComponent(labId)}`);

    const url = `${prefix}/lab_wise_attendance_report_admin?${queryParts.join('&')}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

export const getLabWiseAttendanceReportViewer = (coeId, labType, timeSlot, attendanceName, forDate, labId) => {
    return getReportForAdminByStrength(coeId, labType, timeSlot, attendanceName, forDate, labId, true);
};

export const getAdminCheckInOutReport = (coeId, labType, timeSlot, attendanceName, fromDate, toDate) => {
    const prefix = getAttendanceApiPrefix();
    const url = `${prefix}/checkIn_checkOut_Report_admin?lab_type=${labType}&coeID=${coeId}&timeSlot=${timeSlot}&attendance_name=${attendanceName}&fromDate=${fromDate}&toDate=${toDate}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    return getData(url, { headers });
};

